<template>
  <section class="accordion" :class="[open && fullBleed ? '' : gridXs ? 'container-extra-small' : 'container-small', meta ? 'px-0' : '']">
    <div :class="[(open && fullBleed) || gridWidth ? 'w-full' : 'max-w-wysiwyg', myPages ? 'bg-white shadow-mp' : 'bg-gray-100'].join(' ')">
      <div :class="[open && fullBleed ? (gridXs ? 'container-extra-small mb-4' : 'container-small mb-4') : '', meta ? 'px-0' : '']">
        <div
          class="flex items-center w-full p-4 cursor-pointer md:p-6 row"
          :class="[gridWidth ? '' : 'max-w-wysiwyg', myPages ? 'px-3 py-4 sm:p-4' : ''].join(' ')"
          @click="handleToggle"
          role="term"
          :data-click-id="dataId"
          :data-click-parent="dataParent"
          :data-click-index="dataIndex">
          <h3 class="mr-6 pointer-events-none">{{ heading }}</h3>
          <p v-if="meta" class="mr-6 pointer-events-none whitespace-nowrap">{{ meta }}</p>
          <button class="flex items-center justify-center flex-none w-10 h-10 ml-auto rounded-full pointer-events-none bg-orange-light focus:outline-black-alt">
            <img v-if="open" height="40" width="40" src="../../../assets/images/round-minus.svg" alt="" />
            <img v-else height="40" width="40" src="../../../assets/images/round-plus.svg" alt="" />
          </button>
        </div>
        <div role="definition" ref="accordionslot" class="px-4 pb-6 md:px-6" :class="open ? 'block' : 'hidden'">
          <slot />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import * as Vue from 'vue'
// import store from '../../../store'
import { createApp, defineAsyncComponent } from 'vue'

export default {
  name: 'EllevioWebAccordionItem',
  props: {
    heading: {
      type: String,
      default: ''
    },
    meta: {
      type: String,
      default: ''
    },
    gridXs: {
      type: Boolean,
      default: false
    },
    openFaq: {
      type: Boolean,
      default: false
    },
    fullBleed: {
      type: Boolean,
      default: false
    },
    gridWidth: {
      type: Boolean,
      default: false
    },
    myPages: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: String,
      default: ''
    },
    dataIndex: {
      type: String,
      default: ''
    },
    dataParent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: false
    }
  },
  mounted() {
    this.open = this.openFaq
    this.$refs.accordionslot.querySelectorAll('table:not(.wysiwyg-table)').forEach((table, index) => {
      const accordionInitialIndex = 100 + index
      const componentRoot = document.createElement('div')

      table.setAttribute('id', 'index-' + accordionInitialIndex)
      table.parentNode.insertBefore(componentRoot, table.nextSibling)

      createApp({
        template: `<ellevio-web-table :insideAccordion="true" :tableIndex="${accordionInitialIndex}" />`
      })
        .component(
          'EllevioWebTable',
          defineAsyncComponent(() => import('./Table.vue'))
        )
        .mount(componentRoot)

      // new Vue({
      //   store,
      //   el: componentRoot,
      //   components: {
      //     EllevioWebTable: () => import('./Table.vue')
      //   },
      //   template: `<ellevio-web-table :insideAccordion="true" :tableIndex="${accordionInitialIndex}" />`
      // })
    })
  },
  methods: {
    handleToggle() {
      this.open = !this.open
    }
  }
}
</script>
<style>
.accordion h3 {
  word-break: break-word;
}
</style>
